<div class="photo">
  <div class="photoContainer">
    <div class="placeholder">
      <lib-tablo-face-cropper
        [selectedPoint]="hasFocalPoint$ | async"
        [x]="$safeNavigationMigration((currentFocalPoint | async)?.x)"
        [y]="$safeNavigationMigration((currentFocalPoint | async)?.y)"
        [scale]="scaleFactor.value"
        (updatedEmitter)="pointUpdatedByHand($event)"
        (scaleChanged)="scaleFactor.setValue($event)"
        [imageSize]="currentPhotoSize"
        [url]="
          {
            photoId: $safeNavigationMigration((pickedPhotoId$ | async)?.photoId)
          }
            | getImageUrl
              : $safeNavigationMigration((pickedPhotoId$ | async)?.groupId)
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-tablo-face-cropper>
    </div>
  </div>
  <div class="options">
    Powiększenie
    <input
      type="range"
      [formControl]="scaleFactor"
      min="1"
      max="3"
      step="0.01"
    />
    Obrót
    <div class="rotationContainer">
      <input
        type="range"
        [formControl]="rotation"
        min="-180"
        max="180"
        step="0.1"
      />
      <lib-button icon-only (click)="resetRotation()">
        <mat-icon> refresh </mat-icon>
      </lib-button>
    </div>
  </div>
</div>
